/*** IMPORTS FROM imports-loader ***/
var define = false;

import Player from '@vimeo/player'
/* eslint-disable */
require('../modernizr')

const setupCuePoints = player => {
    let playedOnce = false

    const videoCaption = document.querySelector('.video-caption')

    player.addCuePoint(0, { customKey: 'visionCollaboration' })
        .catch(error => console.log(error))

    player.addCuePoint(4.5, { customKey: 'materialsResources' })
        .catch(error => console.log(error))

    player.addCuePoint(9.5, { customKey: 'precisionCraftsmanship' })
        .catch(error => console.log(error))

    player.addCuePoint(14.5, { customKey: 'technologyInnovation' })
        .catch(error => console.log(error))

    player.on('cuepoint', event => {
        if (event.data.customKey === 'visionCollaboration') {
            if (playedOnce) videoCaption.style.opacity = 0
        } else {
            videoCaption.style.opacity = 0
        }

        setTimeout(() => {
            switch (event.data.customKey) {
                case 'visionCollaboration':
                    videoCaption.innerHTML = 'Vision and Collaboration'
                    break

                case 'materialsResources':
                    videoCaption.innerHTML = 'Materials and Resources'
                    break

                case 'precisionCraftsmanship':
                    videoCaption.innerHTML = 'Precision and Craftsmanship'
                    break

                case 'technologyInnovation':
                    videoCaption.innerHTML = 'Technology and Innovation'
                    playedOnce = true
                    break
            }
        }, 1000)

        setTimeout(() => {
            videoCaption.style.opacity = 1
        }, 1500)
    })
}

const loadBannerVideo = () => {
    const iframe = document.querySelector('.home-video iframe')

    if (iframe && !Modernizr.touchevents) {
        const player = new Player(iframe)

        if (player) {
            setupCuePoints(player)
            player.play()

            setTimeout(() => {
                iframe.style.opacity = 1
            }, 1000)
        }
    }
}

export default loadBannerVideo




// WEBPACK FOOTER //
// ./js/bannerVideo.js